import { BaseHealthProvider } from './base-provider';
import { HealthProvider, HealthActivity, PermissionStatus } from '../types';

/**
 * Web provider - stub implementation for web platform
 * Real implementation would require native Capacitor plugins
 */
export class WebHealthProvider extends BaseHealthProvider {
  name = HealthProvider.NONE;
  
  async isAvailable(): Promise<boolean> {
    // Health sync is not available on web
    return false;
  }
  
  async requestPermissions(): Promise<PermissionStatus> {
    this.log('Health sync not available on web platform');
    return PermissionStatus.DENIED;
  }
  
  async checkPermissions(): Promise<PermissionStatus> {
    return PermissionStatus.DENIED;
  }
  
  async saveActivity(activity: HealthActivity): Promise<boolean> {
    this.log('Cannot save activity on web platform', activity);
    return false;
  }
  
  async getActivities(startDate: Date, endDate: Date): Promise<HealthActivity[]> {
    this.log('Cannot get activities on web platform', { startDate, endDate });
    return [];
  }
}